import React from 'react';

import '@canvas-logic/clp-shared-ui/style.css';
import './reset.css';
import './index.css';

import { App } from './components/App/App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import './i18n';
import './elements/registry';
import './ui-kit/components/ui.css';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App />,
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
